export default "__VITE_ASSET__BwRO8_qL__"